module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/army2.jpg";